export default "__VITE_ASSET__BvN4WSzX__"